import { render, staticRenderFns } from "./CreateSubCondominium.vue?vue&type=template&id=d47be2d2&scoped=true&"
import script from "./CreateSubCondominium.vue?vue&type=script&lang=js&"
export * from "./CreateSubCondominium.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubCondominium.vue?vue&type=style&index=0&id=d47be2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47be2d2",
  null
  
)

export default component.exports